// extracted by mini-css-extract-plugin
export default {"centerFlex":"NoPage_centerFlex__zOkCe"};